import Vue from 'vue'
import { TourManager } from './TourManager'
import Tour from './components/Tour.vue'
import { tourStore } from './store'

// Exportar componentes y tipos para uso directo
export { default as Tour } from './components/Tour.vue'
export { default as TourStep } from './components/TourStep.vue'
export { default as TourOverlay } from './components/TourOverlay.vue'
export { default as TourPopover } from './components/TourPopover.vue'
export * from './models/interfaces'
export { TourManager } from './TourManager'
export { tourStore } from './store'

// Opciones del plugin
interface TourPluginOptions {
  vuex?: boolean
  registerComponents?: boolean
  store?: any // Store de Vuex
}

// Instancia global del gestor de tours
let tourManager: TourManager

const TourPlugin = {
  /**
   * Función de instalación del plugin
   */
  install (vue: any, options: TourPluginOptions = {}) {
    const {
      vuex = true,
      registerComponents = true,
      store = vue.$store || (vue.prototype.$store) || null,
    } = options

    // Registrar el módulo de Vuex si es necesario
    if (vuex && store) {
      // Verificar si el módulo ya está registrado
      if (!store.state.tour) {
        store.registerModule('tour', tourStore)
      }

      // Crear una instancia del gestor de tours
      tourManager = new TourManager(store)
    } else if (vuex) {
      console.warn('[TourPlugin] No se pudo registrar el módulo de Vuex. Para usar el plugin, pasa el store como opción: Vue.use(TourPlugin, { store })')
    }

    // Registrar componentes globalmente si es necesario
    if (registerComponents) {
      Vue.component('Tour', Tour)
    }

    // Exponer el gestor de tours globalmente
    Vue.prototype.$tourManager = tourManager
  },
}

// Exportar el plugin como default para usar con Vue.use()
export default TourPlugin

// Función para obtener la instancia del gestor de tours
export function getTourManager (): TourManager {
  if (!tourManager) {
    throw new Error('[TourPlugin] El plugin no ha sido inicializado. Asegúrate de llamar a Vue.use(TourPlugin, { store }) antes de usar getTourManager()')
  }
  return tourManager
}
